export default __webpack_public_path__ + "static/media/offerImage.f5235aaf.png";